import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import { defineNuxtPlugin, isVue2, useRuntimeConfig } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const options = { ...config.public.bugsnag };
  options.plugins = [new BugsnagPluginVue()];
  options.onError = (event) => {
    event.errors[0].stacktrace = event.errors[0].stacktrace.map((row) => {
      row.file = row.file.replace("file://", "");
      return row;
    });
  };
  let client = Bugsnag._client;
  if (client === null) {
    client = Bugsnag.start(options);
  }
  nuxtApp.vueApp.provide("bugsnag-client", client);
  const vuePlugin = client.getPlugin("vue");
  if (isVue2) {
    vuePlugin.installVueErrorHandler(nuxtApp.vueApp);
  } else {
    nuxtApp.vueApp.use(vuePlugin);
  }
  return {
    provide: {
      bugsnag: client
    }
  };
});
